import React from "react";

const SaleRateRabiCropsVegetables = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Sale Rate of Rabi Seeds - Vegetables</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "" }}
      >
        <div className="row mb-1 justify-content-between">
          <div className="col-lg-12 mb-1">
            <h6>Our seed remains available easily at:</h6>

            <ol>
              <li>HSDC sale counters.</li>
              <li>
                Farmers&#39; Service Centres of Haryana Agro Industries
                Corporation.
              </li>
              <li>Mini Banks.</li>
              <li>Co-op. Societies of HAFED.</li>
              <li>Farmers&#39; Service Centres of HLRDC.</li>
            </ol>

            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th colspan="8">Sale Rate for Rabi 2025-26</th>
                  </tr>
                  <tr>
                    <th>Sr. No</th>
                    <th>Crop</th>
                    <th>Variety</th>
                    <th>Packing Size</th>
                    <th>Full Sale Rate(In Rs. per Kg.)
                    </th>
                    <th>Subsidy(In Rs. per Kg.)</th>
                    <th>Subsidized sale rate(In Rs. per Kg.)
                    </th>
                    <th>Packing wise Sale Rate
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Methi</td>
                    <td>All varieties</td>
                    <td>50 gm</td>
                    <td>112</td>
                    <td>0</td>
                    <td>112</td>
                    <td>Rs.6/-</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Coriander</td>
                    <td>All varieties</td>
                    <td>30 gm</td>
                    <td>189</td>
                    <td>0</td>
                    <td>189</td>
                    <td>Rs.6/-</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Radish</td>
                    <td>All varieties</td>
                    <td>10 gm</td>
                    <td>236</td>
                    <td>0</td>
                    <td>236</td>
                    <td>Rs.3/-</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Turnip</td>
                    <td>All varieties</td>
                    <td>10 gm</td>
                    <td>276</td>
                    <td>0</td>
                    <td>276</td>
                    <td>Rs.3/-</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Pea</td>
                    <td>All varieties</td>
                    <td>100 gm</td>
                    <td>120</td>
                    <td>0</td>
                    <td>120</td>
                    <td>Rs.12/-</td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleRateRabiCropsVegetables;
